import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-comment-item',
  templateUrl: './skeleton-comment-item.component.html',
  styleUrls: ['./skeleton-comment-item.component.css']
})
export class SkeletonCommentItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
